"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _Text, _Text2, _Text3, _Text4, _Text5, _Button;
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { validEmailPattern, validNzMobilePattern } from '@autoguru/components';
import { FormikOdField } from '@autoguru/forms';
import { CheckCircleIcon } from '@autoguru/icons';
import { Box, Button, Column, Columns, Icon, SelectInput, Stack, Text, TextInput, useTextStyles } from '@autoguru/overdrive';
import { withFormik } from 'formik';
import { useCallback } from 'react';
import { object as yupObject, string as yupString } from 'yup';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const arrBusinessTypeOptions = [{
  id: 0,
  option: ''
}, {
  id: 1,
  option: 'I work as an auto repairer/specialist'
}, {
  id: 2,
  option: 'I work in fleet management'
}, {
  id: 3,
  option: 'Other'
}];
let optionSelected;
const showAutoRepairerDisclaimer = () => {
  return _Text || (_Text = /*#__PURE__*/_jsxs(Text, {
    children: [/*#__PURE__*/_jsx(Text, {
      strong: true,
      children: "If you're an auto repairer"
    }), " please note that at this stage only Custom Fleet approved auto specialists are eligible to use AutoGuru for fleet bookings in New Zealand. We'll let you know if that changes."]
  }));
};
const showFleetManagementDisclaimer = () => {
  return _Text2 || (_Text2 = /*#__PURE__*/_jsxs(Text, {
    children: [/*#__PURE__*/_jsx(Text, {
      strong: true,
      children: "If you work in fleet management or have another enquiry"
    }), ", a member of our team will be in touch."]
  }));
};
const showAutoRepairerAndFleetDisclaimer = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showAutoRepairerDisclaimer(), showFleetManagementDisclaimer()]
  });
};
export const formSubmittedSuccessfully = () => {
  var _optionSelected, _optionSelected2;
  return /*#__PURE__*/_jsx(Box, {
    as: "fieldset",
    backgroundColour: "white",
    borderWidth: ['none', 'none', '1'],
    borderColour: "gray",
    borderRadius: "1",
    padding: "4",
    children: /*#__PURE__*/_jsxs(Stack, {
      space: "5",
      children: [/*#__PURE__*/_jsx(Box, {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/_jsx(Icon, {
          size: "large",
          icon: CheckCircleIcon,
          className: useTextStyles({
            colour: 'primary'
          })
        })
      }), _Text3 || (_Text3 = /*#__PURE__*/_jsx(Text, {
        children: "Thanks for expressing your interest in AutoGuru to simplify fleet maintenance."
      })), ((_optionSelected = optionSelected) === null || _optionSelected === void 0 ? void 0 : _optionSelected.indexOf(arrBusinessTypeOptions[1].option)) !== -1 ? showAutoRepairerDisclaimer() : ((_optionSelected2 = optionSelected) === null || _optionSelected2 === void 0 ? void 0 : _optionSelected2.indexOf(arrBusinessTypeOptions[2].option)) !== -1 ? showFleetManagementDisclaimer() : showAutoRepairerAndFleetDisclaimer(), _Text4 || (_Text4 = /*#__PURE__*/_jsx(Text, {
        children: "Cheers,"
      })), _Text5 || (_Text5 = /*#__PURE__*/_jsx(Text, {
        children: "The AutoGuru crew"
      }))]
    })
  });
};
export const LearnMoreForm = withFormik({
  validationSchema: yupObject().shape({
    name: yupString().typeError("Name isn't valid").required('Name is required').min(2, 'Name must be at least 2 characters').max(40, 'Name must be less than 40 characters').nullable(false),
    phoneNumber: yupString().typeError("Phone number isn't valid").required('Phone number is required').matches(validNzMobilePattern, 'Must be a valid New Zealand mobile number').nullable(true),
    emailAddress: yupString().typeError("Email address isn't valid").required('Email address is required').matches(validEmailPattern, 'Email address must be a valid email address').nullable(false),
    businessName: yupString().typeError("Business name isn't valid").required('Business name is required').min(2, 'Business name must be at least 2 characters').max(40, 'Business name must be less than 40 characters').nullable(false),
    city: yupString().typeError("City/Town isn't valid").required('City/Town is required').min(2, 'City/Town must be at least 2 characters').max(40, 'City/Town must be less than 40 characters').nullable(false),
    businessType: yupString().typeError("Business Type isn't valid").required('Business Type is required').nullable(true)
  }),
  mapPropsToValues() {
    return {
      name: '',
      phoneNumber: '',
      emailAddress: '',
      businessName: '',
      city: '',
      businessType: ''
    };
  },
  handleSubmit(form, {
    props
  }) {
    optionSelected = form.businessType;
    props.onSubmit(_objectSpread({}, form));
  }
})(form => {
  return /*#__PURE__*/_jsx(Box, {
    as: "form",
    noValidate: true,
    onSubmit: useCallback(event => {
      for (const field of Object.keys(form.values)) {
        form.setFieldTouched(field, true);
      }
      form.handleSubmit(event);
    }, [form.handleSubmit, form.values, form.setFieldTouched]),
    id: "learn-more",
    children: !form.isFormSubmitted ? /*#__PURE__*/_jsx(Box, {
      as: "fieldset",
      padding: "5",
      backgroundColour: "white",
      borderWidth: ['none', 'none', '1'],
      borderColour: "gray",
      borderRadius: "1",
      children: /*#__PURE__*/_jsxs(Stack, {
        space: "5",
        children: [/*#__PURE__*/_jsx(Stack, {
          space: "7",
          children: /*#__PURE__*/_jsxs(Columns, {
            space: "4",
            children: [/*#__PURE__*/_jsx(Column, {
              width: ['full', '1/2'],
              children: /*#__PURE__*/_jsx(FormikOdField, {
                field: TextInput,
                name: "name",
                placeholder: "Name"
              })
            }), /*#__PURE__*/_jsx(Column, {
              width: ['full', '1/2'],
              children: /*#__PURE__*/_jsx(FormikOdField, {
                field: TextInput,
                placeholder: "Phone number",
                name: "phoneNumber"
              })
            }), /*#__PURE__*/_jsx(Column, {
              width: "full",
              children: /*#__PURE__*/_jsx(FormikOdField, {
                field: TextInput,
                placeholder: "Email",
                name: "emailAddress"
              })
            }), /*#__PURE__*/_jsx(Column, {
              width: ['full', '1/2'],
              children: /*#__PURE__*/_jsx(FormikOdField, {
                field: TextInput,
                placeholder: "Business name",
                name: "businessName"
              })
            }), /*#__PURE__*/_jsx(Column, {
              width: ['full', '1/2'],
              children: /*#__PURE__*/_jsx(FormikOdField, {
                field: TextInput,
                placeholder: "City/Town",
                name: "city"
              })
            }), /*#__PURE__*/_jsx(Column, {
              width: "full",
              children: /*#__PURE__*/_jsx(FormikOdField, {
                field: SelectInput,
                placeholder: "Select your business type",
                name: "businessType",
                children: arrBusinessTypeOptions.map(typeOptions => /*#__PURE__*/_jsx("option", {
                  value: typeOptions.option,
                  children: typeOptions.option
                }, typeOptions.option))
              })
            })]
          })
        }), _Button || (_Button = /*#__PURE__*/_jsx(Button, {
          isFullWidth: true,
          variant: "primary",
          type: "submit",
          children: "Learn more"
        }))]
      })
    }) : formSubmittedSuccessfully()
  });
});